import {useState, useCallback, useEffect, useRef} from 'react';
import {checkGeoPermissionAllowed, getGeoPermission} from '@/common/helpers/geolocation/geolocationHelper';

export function useGeoPermissionState() {
	const [permissionState, setPermissionState] = useState<undefined | PermissionState>();

	const activePermissionStatusRef = useRef<PermissionStatus | undefined>();
	const requireCheck = useCallback(() => {
		if (activePermissionStatusRef.current) {
			activePermissionStatusRef.current.onchange = null;
		}

		if (!checkGeoPermissionAllowed()) {
			// Safari and old browsers
			setPermissionState('prompt');
			return;
		}

		getGeoPermission().then(
			permission => {
				setPermissionState(permission.state);
				activePermissionStatusRef.current = permission;

				// Listen to change
				permission.onchange = () => {
					setPermissionState(permission.state);
				};
			},
			error => {
				setPermissionState('prompt');
				throw error;
			},
		);
	}, []);

	// Check geolocation access permissions
	useEffect(requireCheck, []);

	// Reset active stats change listener
	useEffect(() => {
		if (activePermissionStatusRef.current) {
			activePermissionStatusRef.current.onchange = null;
		}
	}, []);

	// TODO maybe manual check method is not needed if we listen permission change
	return [permissionState, requireCheck] as const;
}

useGeoPermissionState.displayName = 'useGeoPermissionState';
